import { Injectable, inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subscription, interval, filter } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../features/auth/services/auth.service';
import { ApiResponse } from '../models/api-response.model';

export interface NotificacionResponse {
  id: number;
  titulo: string;
  mensaje: string;
  tipo: string;
  severidad: string;
  enlace: string | null;
  referenciaId: number | null;
  leida: boolean;
  fechaCreacion: string;
  fechaLectura: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class NotificacionAppService implements OnDestroy {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private baseUrl = `${environment.apiUrl}/notificaciones`;

  private cantidadNoLeidas$ = new BehaviorSubject<number>(0);
  private pollingSub: Subscription | null = null;
  private pollingInterval = 60000;

  getCantidadNoLeidas(): Observable<number> {
    return this.cantidadNoLeidas$.asObservable();
  }

  iniciarPolling() {
    this.detenerPolling();
    this.actualizarContador();

    this.pollingSub = interval(this.pollingInterval).pipe(
      filter(() => this.authService.isAuthenticated())
    ).subscribe(() => this.actualizarContador());
  }

  detenerPolling() {
    this.pollingSub?.unsubscribe();
    this.pollingSub = null;
  }

  actualizarContador() {
    if (!this.authService.isAuthenticated()) return;

    this.http.get<ApiResponse<number>>(`${this.baseUrl}/contador`).subscribe({
      next: (response) => {
        if (response.success) {
          this.cantidadNoLeidas$.next(response.data);
        }
      },
      error: () => {}
    });
  }

  obtenerNoLeidas(): Observable<ApiResponse<NotificacionResponse[]>> {
    return this.http.get<ApiResponse<NotificacionResponse[]>>(`${this.baseUrl}/no-leidas`);
  }

  marcarComoLeida(id: number): Observable<ApiResponse<string>> {
    return this.http.patch<ApiResponse<string>>(`${this.baseUrl}/${id}/leer`, {});
  }

  marcarTodasComoLeidas(): Observable<ApiResponse<string>> {
    return this.http.patch<ApiResponse<string>>(`${this.baseUrl}/leer-todas`, {});
  }

  ngOnDestroy() {
    this.detenerPolling();
  }
}
